import { render, staticRenderFns } from "./AnalysisPanel.vue?vue&type=template&id=08640e6f&scoped=true&"
import script from "./AnalysisPanel.vue?vue&type=script&lang=js&"
export * from "./AnalysisPanel.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisPanel.vue?vue&type=style&index=0&id=08640e6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08640e6f",
  null
  
)

export default component.exports